import { useCallback, useRef } from "react";

// Remembers WHY a search box's row is highlighted, for utils/searchEnter
// resolveEnterPick: "auto" when MUI's autoHighlight put it there, "keyboard" /
// "mouse" / "touch" when the person chose it. Spread `onHighlightChange` onto the
// <Autocomplete>; read `reasonRef.current` when Enter arrives.
const useAutoHighlightReason = () => {
  const reasonRef = useRef("auto");
  const onHighlightChange = useCallback((e, option, reason) => {
    reasonRef.current = reason || "auto";
  }, []);
  return { reasonRef, onHighlightChange };
};

export default useAutoHighlightReason;
